import type { Measure } from "~/modules/measures/types";
import { MEASURE_UNIT_LABELS } from "~/modules/measures/consts";
import { getMeasureURL } from "~/routes";
import {
    CatalogListItem,
    type CatalogListItemBadge,
} from "~/modules/catalog/components/CatalogListItem";

export function MeasureItem({
    measure,
    totalAssetCount,
}: {
    measure: Measure;
    totalAssetCount?: number;
}) {
    const badges: CatalogListItemBadge[] = [
        ...(measure.category
            ? [
                  {
                      title: "Category",
                      label: measure.category,
                  },
              ]
            : []),
        {
            title: "Assets",
            label:
                totalAssetCount !== undefined
                    ? `${measure.asset_count.toLocaleString()} / ${totalAssetCount.toLocaleString()}`
                    : `${measure.asset_count.toLocaleString()}`,
        },
        {
            title: "Unit",
            label: MEASURE_UNIT_LABELS[measure.unit],
        },
        {
            title: "Slug",
            label: measure.slug,
            mono: true,
        },
    ];

    return (
        <CatalogListItem
            label={measure.display_name}
            slug={measure.slug}
            href={getMeasureURL({ measureSlug: measure.slug })}
            description={measure.short_description}
            icon={measure.icon}
            color={measure.color}
            badges={badges}
        />
    );
}
